import React, { useCallback } from 'react';
import { IconColor } from '@trello/nachos/icon';
import { StarIcon } from '@trello/nachos/icons/star';
import { StarredIcon } from '@trello/nachos/icons/starred';
import styles from './StarredIcons.less';
import classNames from 'classnames';
import { forTemplate } from '@trello/i18n';

const format = forTemplate('board_item');

interface StarredIconProps {
  readonly isStarred: boolean;
  starColor?: IconColor | undefined;
}

export const StarredIcons: React.FC<StarredIconProps> = ({
  isStarred,
  starColor,
}) => {
  const getCustomStarColorStyles = useCallback(() => {
    if (starColor) {
      if (isStarred) {
        return styles.starredBoardIconCustomStarColor;
      } else {
        return styles.unstarredBoardIconCustomStarColor;
      }
    }
  }, [isStarred, starColor]);

  return (
    <div
      className={classNames(
        isStarred ? styles.starredBoardIcon : styles.unstarredBoardIcon,
        getCustomStarColorStyles(),
      )}
    >
      <StarIcon
        size="small"
        label={format('star-icon')}
        color={starColor ? starColor : 'gray'}
        dangerous_className={styles.starIcon}
      />
      <StarredIcon
        size="small"
        color={starColor ? starColor : 'yellow'}
        label={format('starred-icon')}
        dangerous_className={styles.starredIcon}
      />
    </div>
  );
};
